import { ProgramDescriptionAccordion } from '@components/buzzkuri/shared/uiParts/accordion/ProgramDescription'
// import { ResizeObserver } from '@juggle/resize-observer'
import useResizeObserver from 'use-resize-observer/polyfilled'
import React, { useEffect, useRef } from 'react'
import { RefWrappedDigestMovieContent } from './Content'
import { useContext } from 'react'
import { WindowSizeContext } from '@context/WindowSize/Context'
import { BREAKPOINTS } from '@constants/common'

type Props = {
  digestMovie: string
}

export const DigestMovie = ({ digestMovie }: Props): JSX.Element => {
  const { ref, height = 1 } = useResizeObserver<HTMLDivElement>()
  const videoRef = useRef<HTMLVideoElement>(null)
  const winSize = useContext(WindowSizeContext)

  useEffect(() => {
    // アコーディオンが閉じた時に動画をポーズ
    if (height && height < 300) {
      videoRef.current?.pause()
    }
  }, [height])

  return (
    <div className="lg:w-[65.2vw]" ref={ref}>
      <ProgramDescriptionAccordion
        title={
          winSize?.width > BREAKPOINTS.laptop
            ? '研修イメージ（ダイジェスト動画）'
            : `研修イメージ\n（ダイジェスト動画）`
        }
      >
        <RefWrappedDigestMovieContent {...{ digestMovie }} ref={videoRef} />
      </ProgramDescriptionAccordion>
    </div>
  )
}
